/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import gitStatesImg from 'assets/images/gitStates.png'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h3 className={styles.h2}>2 - Секции Git-проекта</h3>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <code className={styles.code}>Рабочая директория (working directory)</code> - является снимком версии проекта.
        Файлы распаковываются из сжатой базы данных в Git-директории и располагаются на диске, для того чтобы их можно
        было изменять и использовать.
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>Область подготовленных файлов (staging area)</code> - это файл, располагающийся в
        вашей Git-директории, в нём содержится информация о том, какие изменения попадут в следующий коммит. Эту область
        ещё называют “индекс”, однако называть её <code className={styles.code}>stage</code> также общепринято.
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>Git-директория (git directory)</code> - это то место, где Git хранит метаданные и
        базу объектов вашего проекта. Это самая важная часть Git, и это та часть, которая копируется при клонировании
        репозитория с другого компьютера.
      </li>
    </ul>
    <img className={styles.img} src={gitStatesImg} alt="git states" />
  </section>
))
